<template>
    <b-overlay no-center :show="isOverlayDisplayed && (displayedOverlay === objectDashboardOverlayEnum.NoDashboard || displayedOverlay === objectDashboardOverlayEnum.Loading)" :opacity="overlayOpacity" class="h-100 w-100">
        <b-container fluid class="d-flex flex-column mh-100 h-100 w-100">
            <!-- Sélecteur de période-->
            <!-- <b-row>
                <b-col cols="auto" align-self="center" class="py-2">
                    <b-button disabled variant="outline-secondary" class="btn-circle">
                        <font-awesome-icon icon="calendar-days"  />
                    </b-button>
                </b-col>
                <b-col cols="auto" align-self="center" class="px-0">
                    <b-button disabled variant="outline-secondary" class="btn-circle">
                        <font-awesome-icon icon="circle-arrow-left"   />
                    </b-button>
                </b-col>
                <b-col align-self="center">
                    <h3 class="m-0 text-secondary p-0" >juillet 2023</h3>
                </b-col>
                <b-col cols="auto" align-self="center" class="">
                    <b-button disabled variant="outline-secondary" class="btn-circle">
                        <font-awesome-icon icon="circle-arrow-right" />
                    </b-button>
                </b-col>
            </b-row> -->
            
            <b-row class="flex-grow-1 overflow-auto">
                <b-col class="d-flex flex-column py-0">
                    <!-- Affichage d'une grille contenant les widgets du dashboard object -->
                    <grid-layout v-if="dash && Object.keys(dash).length > 0 && dash.Widgets && dash.Widgets.length > 0" :layout.sync="dash.Widgets"
                                :col-num="12"
                                :row-height="30"
                                :is-draggable="true"
                                :is-resizable="true"
                                :is-mirrored="false"
                                :margin="[10, 10]"
                                :use-css-transforms="false"
                                :responsive="($screen.breakpoint === 'xs' || $screen.breakpoint === 'sm')"
                                :vertical-compact="false"
                                :prevent-collision="false"
                                :autoSize="true"
                                class="h-100 w-100 bg-white">
                        <grid-item v-for="widget in dash.Widgets" :x="widget.x" :y="widget.y" :w="widget.w" :h="widget.h" :i="widget.i" :key="widget.Id" static>
                            <WidgetContainer :DashboardId="dash.Id" :WidgetId="widget.Id" :Title="widget.Name" 
                                :WidgetLibrary="widgetLibrary(widgetTypeEnum[widget.Type])"  
                                :TargetDashboard="dashboardTypeEnum.Object" 
                                :Parameters="widget.Parameters" :PropToWatch="NodeId" :InError="widget.InError"
                                CustomStoreTarget="ObjectStore"
                                :Action="getAction()"
                                :AutoSize="true" :EditMode="false" :DisplayConfigButton="false" :DisplayExportButton="true" :DisplayNodesConfig="false" />
                        </grid-item>
                    </grid-layout>
                </b-col>
            </b-row>
        </b-container>
        <template #overlay>
            <!-- Affichage d'un message si aucun noeud n'a été sélectionné -->
            <Welcome v-if="displayedOverlay === objectDashboardOverlayEnum.NoDashboard" :DisplayBrand="false" :Variant="Variant" class="flex-grow-1">
                <!-- Suppression message de bienvenue par défaut-->
                <template v-slot:MiscContent>
                    <!-- NoDashboardMessage : Aucun tableau de bord n'a été paramétré pour cet objet -->
                    <h4 class="text-center">{{$t('NoDashboardMessage')}}</h4>
                </template>
            </Welcome>
            <!-- Overlay de chargement -->
			<Welcome v-if="displayedOverlay === objectDashboardOverlayEnum.Loading" :DisplayBrand="false" :Loading="false" :Variant="Variant" class="text-center">
				<template v-slot:MiscContent>
                    <div class="b-skeleton w-100 b-skeleton-icon b-skeleton-animate-fade bg-transparent text-gray-middle-dark pt-4" align-v="center">
                        <b-icon icon="file-richtext-fill" font-scale="7"/>
                    </div>
                    <!-- DashboardPreparationTitle : Tableau de bord objet en préparation -->
                    <h4 class="pt-4">{{$t('DashboardPreparationTitle')}}</h4>
                     <!-- DashboardDataLoading : Récupération des données associées -->
                    <h6>{{$t('DashboardDataLoading')}}</h6>
				</template>
			</Welcome>
        </template>
    </b-overlay>
</template>

<script lang="ts">
    import { defineAsyncComponent } from 'vue';
    import Component, { mixins } from 'vue-class-component';
    import { Getter } from 'vuex-class';
    import VueGridLayout from 'vue-grid-layout';
    import TObjectDashboard from '@/types/Dashboard/ObjectDashboard/ObjectDashboard';
    import DashboardTypeEnum from '@/enums/DashboardTypeEnum';
    import WidgetTypeEnum from '@/enums/WidgetTypeEnum';
    import OverlayEnum from '@/enums/OverlayEnum';
    import tWidgetLibrary from '@/types/Dashboard/WidgetLibrary';
    import Welcome from '@/components/commons/Welcome.vue';
    import { OverlayUtils } from '@/components/commons/Utils';
    import locales from "./locales/ObjectDashboard.json";
    import { BaseObjectForm } from './BaseObjectForm';

    /** Composant de tableau de bord objet */
    @Component({
        components: {
            GridLayout: VueGridLayout.GridLayout,
            GridItem: VueGridLayout.GridItem,
            WidgetContainer: defineAsyncComponent(() => import("@/components/commons/Dashboard/WidgetContainer.vue")),
            Welcome
        },
        i18n: { messages: locales }
    })
    export default class ObjectDashboard extends mixins(BaseObjectForm, OverlayUtils<typeof ObjectDashboardOverlayEnum>) {
        /** Pour rendre accessible l'enum dans la section template */
        private dashboardTypeEnum = DashboardTypeEnum;
        private widgetTypeEnum = WidgetTypeEnum;
        private objectDashboardOverlayEnum = ObjectDashboardOverlayEnum;

        /** Récupère l'action du tableau de bord en cours */
        private getAction() {
            return this.$store.getters['GetMasterAction'](this.dashboardTypeEnum[DashboardTypeEnum.Object].toString() + 'Dashboard');
        }

        /** Méta-données d'un type de widget (bibliothèque de widgets) */
        @Getter('WidgetLibraryStore/GetWidgetLibrary')
        private widgetLibrary: (widgetType: string)=> tWidgetLibrary;

        /** Tableau de bord objet chargé */
        private dash: TObjectDashboard = new TObjectDashboard();

        async created(): Promise<void> {
            this.displayOverlay(ObjectDashboardOverlayEnum.Loading);
            console.debug("ObjectDashboard - created() - form : ", this.form.Sections[0]);
            this.dash = this.form.Sections[0].Value;
            this.hideOverlay();
        }
    }

    /** Etend OverlayEnum avec des valeurs spécifiques au dashboard objet */
    const ObjectDashboardOverlayEnum = { ...OverlayEnum, NoDashboard: 4 }
    type ObjectDashboardOverlayEnum = typeof ObjectDashboardOverlayEnum[keyof typeof ObjectDashboardOverlayEnum];

</script>

<style scoped>
    /** Styles utilisés par le Vue-Grid-Layout définis dans App.vue */

    /** Redéfini la couleur d'ombre derrière le déplacement d'un widget */
    :deep(.container .vue-grid-item.vue-grid-placeholder) {
        background: var(--secondary) !important;
    }

    :deep(.vue-grid-item.vue-grid-placeholder) {
        background: var(--secondary) !important;
    }
</style>